import { createAsyncThunk } from '@reduxjs/toolkit';
import bundlesApi from "../../../configs/apis/bundles";
import modulesApi from "../../../configs/apis/modules";

export const getBundleListing = createAsyncThunk(
  'bundle/getListing',
  async (payload, { rejectWithValue }) => bundlesApi
    .getListing({
      page: payload.page,
      length: payload.rowsPerPage,
      search: payload.search,
      status: payload.status,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const getBundle = createAsyncThunk(
  'bundle/get',
  async (payload, { rejectWithValue }) => bundlesApi
    .get({
      id: payload.id,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

// The companies currently on a bundle — what an in-place update would re-flatten. Read only;
// the Edit dialog uses it to tell the admin what Save costs before they press it.
export const getBundleCompanies = createAsyncThunk(
  'bundle/getBundleCompanies',
  async (payload, { rejectWithValue }) => bundlesApi
    .getCompanies({
      id: payload.id,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const createBundle = createAsyncThunk(
  'bundle/create',
  async (payload, { rejectWithValue }) => bundlesApi
    .create({
      name: payload.name,
      code: payload.code,
      description: payload.description,
      moduleIds: payload.moduleIds,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const updateBundle = createAsyncThunk(
  'bundle/update',
  async (payload, { rejectWithValue }) => bundlesApi
    .update({
      id: payload.id,
      name: payload.name,
      description: payload.description,
      sortOrder: payload.sortOrder,
      moduleIds: payload.moduleIds,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const setBundleStatus = createAsyncThunk(
  'bundle/setStatus',
  async (payload, { rejectWithValue }) => bundlesApi
    .setStatus({
      id: payload.id,
      isActive: payload.isActive,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const deleteBundle = createAsyncThunk(
  'bundle/delete',
  async (payload, { rejectWithValue }) => bundlesApi
    .remove({
      id: payload.id,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const getStructure = createAsyncThunk(
  'bundle/getStructure',
  async (payload, { rejectWithValue }) => bundlesApi
    .getStructure()
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

// NOTE: bundles are no longer cloned server-side. A clone copies the source's module set
// verbatim, which the backend's identical-module-set rule now rejects, so that endpoint was
// removed. The "Duplicate" row action opens a PRE-FILLED Add dialog (bundles.container.js)
// and createBundle carries the edited set.

export const getModuleListing = createAsyncThunk(
  'bundle/getModuleListing',
  async (payload, { rejectWithValue }) => modulesApi
    .getListing({
      activeOnly: payload ? payload.activeOnly : undefined,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);
